import requestFunctions from "../../functions/requestFunctions";


export const state = {
  WAREHOUSES_ITEM: {},
  WAREHOUSES_LIST: [],
  WAREHOUSES_TABLE_DATA: [],
  WAREHOUSES_ARRAY_DATA: [],
  WAREHOUSES_TOTAL_ROWS: 0
}

export const getters = {
  GET_WAREHOUSES_ITEM: (state) => {
    return state.WAREHOUSES_ITEM;
  },
  GET_WAREHOUSES_LIST: (state) => {
    return state.WAREHOUSES_LIST;
  },
  GET_WAREHOUSES_TABLE_DATA: (state) => {
    return state.WAREHOUSES_TABLE_DATA;
  },
  GET_WAREHOUSES_ARRAY_DATA: (state) => {
    return state.WAREHOUSES_ARRAY_DATA;
  },
  GET_WAREHOUSES_TOTAL_ROWS: (state) => {
    return state.WAREHOUSES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_WAREHOUSES_ITEM(state, item) {
    state.WAREHOUSES_ITEM = item;
  },

  UPDATE_WAREHOUSES_LIST(state, list) {
    
    state.WAREHOUSES_LIST = list.data;

    state.WAREHOUSES_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.WAREHOUSES_TABLE_DATA = [];
    state.WAREHOUSES_ARRAY_DATA = [];

    list.forEach(el => {

      state.WAREHOUSES_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,

        'name' : el.name,
        'address' : el.address,
        'company_name' : el.company_name,
        'counterparty_name' : el.counterparty_name,
        'comments' : el.comments,

        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.WAREHOUSES_ARRAY_DATA.push({
        id: el.id,
        name: el.name,
        uuid: el.uuid,
      });
    });
  },
}

export const actions = {

  async FETCH_WAREHOUSES_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/warehouses/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_WAREHOUSES_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_WAREHOUSES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/warehouses';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_WAREHOUSES_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_WAREHOUSES_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/warehouses';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_WAREHOUSES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/warehouses/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_WAREHOUSES_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/warehouses/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}